var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEngineeringTechnologyAbroad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 4.125C34.0648 4.14992 29.7455 4.95 26.62 6.33273C24.2877 7.36398 23.375 8.1443 23.375 10.7877V38.5C26.9474 35.2773 30.1177 34.375 42.625 34.375V4.125H39.875ZM4.125 4.125C9.93523 4.14992 14.2545 4.95 17.38 6.33273C19.7123 7.36398 20.625 8.1443 20.625 10.7877V38.5C17.0526 35.2773 13.8823 34.375 1.375 34.375V4.125H4.125Z",
    fill: "#595959"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEngineeringTechnologyAbroad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Engineering&Technology_abroad.b4b9caf7842432a04cc319d168aae6c9.svg";